"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var utilities_1 = require("../../utilities");
var material_1 = require("@angular/material");
var skynet_store_languages_api_1 = require("@synisys/skynet-store-languages-api");
var store_1 = require("@ngrx/store");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var operators_1 = require("rxjs/operators");
var skynet_store_messages_api_1 = require("@synisys/skynet-store-messages-api");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var noop_1 = require("rxjs/util/noop");
require("./export-copy-template-dialog.component.scss");
var lodash_1 = require("lodash");
var LOGGER = utilities_1.createLogger('export-copy-template-dialog');
var ExportCopyTemplateDialogComponent = /** @class */ (function () {
    function ExportCopyTemplateDialogComponent(dialogRef, store, original_name) {
        this.dialogRef = dialogRef;
        this.store = store;
        this.original_name = original_name;
        this.template_name = new idm_crosscutting_concepts_frontend_1.MultilingualStringBuilder().build();
        this.isReady = false;
    }
    ExportCopyTemplateDialogComponent.prototype.cancelAction = function () {
        this.dialogRef.close(undefined);
    };
    ExportCopyTemplateDialogComponent.prototype.copyAction = function () {
        this.dialogRef.close(this.template_name);
    };
    ExportCopyTemplateDialogComponent.prototype.getMessageKey = function (languages) {
        var _this = this;
        if (languages.some(function (l) { return lodash_1.isEmpty(_this.template_name.getValue(l.getId())); })) {
            return 'ng-controls_ui.labels.field-is-required';
        }
        return '';
    };
    ExportCopyTemplateDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.languages$ = skynet_store_languages_api_1.languageStoreManager
            .selectAll(this.store)
            .pipe(operators_1.map(function (languages) { return languages.toList().toArray(); }));
        this.currentLanguage$ = this.store.select(function (s) { return s.languages.currentLanguageId; });
        this.languages$
            .pipe(operators_1.switchMap(function (languages) {
            return combineLatest_1.combineLatest.apply(void 0, languages.map(function (language) {
                return skynet_store_messages_api_1.messageStoreManager.selectOne(_this.store, skynet_store_messages_api_1.MessageKeyFactory({
                    name: 'de.template.duplicate.name_prefix',
                    languageId: language.getId(),
                }));
            })).pipe(operators_1.first(), operators_1.map(function (messages) {
                var builder = new idm_crosscutting_concepts_frontend_1.MultilingualStringBuilder();
                languages.forEach(function (l, i) {
                    return builder.withValueForLanguage(l.getId(), messages[i].value +
                        _this.original_name.getValue(l.getId()));
                });
                return builder.build();
            }), operators_1.tap(function (name) {
                _this.template_name = name;
                _this.isReady = true;
            }));
        }))
            .subscribe(noop_1.noop, function (err) { return LOGGER.error(err); });
    };
    ExportCopyTemplateDialogComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'export-copy-template-dialog',
            template: require('./export-copy-template-dialog.component.html'),
        }),
        __param(2, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [material_1.MatDialogRef,
            store_1.Store,
            idm_crosscutting_concepts_frontend_1.MultilingualString])
    ], ExportCopyTemplateDialogComponent);
    return ExportCopyTemplateDialogComponent;
}());
exports.ExportCopyTemplateDialogComponent = ExportCopyTemplateDialogComponent;
//# sourceMappingURL=export-copy-template-dialog.component.js.map